module.exports = __webpack_public_path__ + "static/media/8.fd455cf6.jpg";